import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Levels } from './components/Levels';
import { Scaffolding } from './components/Scaffolding';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-bone" data-id="element-0" data-mp="31cjou2jzrr2f">
      <MetaPixel data-id="element-1" data-mp="2wjqgl4pbe0ll" />
      <CountdownBar data-id="element-2" data-mp="2wj8ehrfz0s5r" />
      <main data-id="element-3" data-mp="2wip6p3k1bk5g">
        <Hero data-id="element-4" data-mp="2wi5nzkmk8rqd" />
        <Marquee data-id="element-5" data-mp="28ufm24yk52fw" />
        <Levels data-id="element-6" data-mp="28tw972nrl48q" />
        <Scaffolding data-id="element-7" data-mp="28te4dhn1dhp7" />
        <Difference data-id="element-8" data-mp="28sl3uyeo7ofi" />
        <WhatsInside data-id="element-9" data-mp="28s2ztflro5x1" />
        <Bonuses data-id="element-10" data-mp="23vkzcrxgytqi" />
        <Offer data-id="element-11" data-mp="23w4c7u89irxo" />
        <Guarantee data-id="element-12" data-mp="23ujl6el5pr4k" />
        <Faq data-id="element-13" data-mp="23v2u55stx56g" />
      </main>
      <Footer data-id="element-14" data-mp="3ijxoypkvdyjd" />
    </div>;
}